import React, { useEffect, useRef, useState } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";

const Dropdown = ({ isOpen, onToggle, title, body }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);

  return (
    <div className="cursor-pointer">
      <div
        className="inline-flex items-center justify-between w-full"
        onClick={onToggle}
      >
        <div className="text-[#FFFFFF] font-poppins text-[14px]">{title}</div>
        <RiArrowDropDownLine
          onClick={onToggle}
          className="text-[#FFFFFF] text-lg"
        />
      </div>
      <div
        ref={contentRef}
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: isOpen ? `${height}px` : "0px",
        }}
      >
        <div className="pt-2">
          {/* Dropdown content here */}
          <p className="text-[#FFFFFF]">{body}</p>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
